import gql from "graphql-tag";

export default gql`
	mutation caesarsInvestmentOrders($orders: [String!]!, $missing_payment: Float) {
		caesarsInvestmentOrders(orders: $orders, missingPayment: $missing_payment) {
			success
		}
	}
`;
